import type {LocaleMessages} from './types';

export const pt: LocaleMessages = {
    common: {
        actions: {
            save: 'Salvar',
            cancel: 'Cancelar',
            delete: 'Excluir',
            edit: 'Editar',
            update: 'Atualizar',
            create: 'Criar',
            submit: 'Enviar',
            reset: 'Redefinir',
            clear: 'Limpar',
            search: 'Pesquisar',
            filter: 'Filtrar',
            sort: 'Ordenar',
            refresh: 'Atualizar',
            reload: 'Recarregar',
            back: 'Voltar',
            next: 'Próximo',
            previous: 'Anterior',
            continue: 'Continuar',
            finish: 'Finalizar',
            close: 'Fechar',
            open: 'Abrir',
            show: 'Mostrar',
            hide: 'Ocultar',
            copy: 'Copiar',
            paste: 'Colar',
            cut: 'Cortar',
            select: 'Selecionar',
            selectAll: 'Selecionar tudo',
            deselect: 'Desmarcar',
            confirm: 'Confirmar',
            deny: 'Negar',
            approve: 'Aprovar',
            reject: 'Rejeitar',
            retry: 'Tentar novamente',
            undo: 'Desfazer',
            redo: 'Refazer',
        },

        status: {
            loading: 'Carregando',
            success: 'Sucesso',
            error: 'Erro',
            warning: 'Aviso',
            info: 'Informação',
            pending: 'Pendente',
            completed: 'Concluído',
            failed: 'Falhou',
            cancelled: 'Cancelado',
            active: 'Ativo',
            inactive: 'Inativo',
            enabled: 'Habilitado',
            disabled: 'Desabilitado',
            online: 'Online',
            offline: 'Offline',
            connected: 'Conectado',
            disconnected: 'Desconectado',
        },

        timeAgo: {
            justNow: 'agora mesmo',
            minutesAgo: 'há {count} minutos',
            hoursAgo: 'há {count} horas',
            daysAgo: 'há {count} dias',
            weeksAgo: 'há {count} semanas',
            monthsAgo: 'há {count} meses',
            yearsAgo: 'há {count} anos',
        },

        navigation: {
            home: 'Início',
            dashboard: 'Painel',
            profile: 'Perfil',
            settings: 'Configurações',
            help: 'Ajuda',
            support: 'Suporte',
            documentation: 'Documentação',
            feedback: 'Feedback',
            about: 'Sobre',
            privacy: 'Privacidade',
            terms: 'Termos',
            contact: 'Contato',
        },

        general: {
            yes: 'Sim',
            no: 'Não',
            ok: 'OK',
            maybe: 'Talvez',
            none: 'Nenhum',
            all: 'Todos',
            other: 'Outro',
            unknown: 'Desconhecido',
            optional: 'Opcional',
            required: 'Obrigatório',
            recommended: 'Recomendado',
            advanced: 'Avançado',
            basic: 'Básico',
            custom: 'Personalizado',
            default: 'Padrão',
            example: 'Exemplo',
            placeholder: 'Marcador',
            noData: 'Não há dados disponíveis',
            noResults: 'Nenhum resultado encontrado',
            empty: 'Vazio',
            total: 'Total',
            subtotal: 'Subtotal',
            count: 'Contagem',
            limit: 'Limite',
            unlimited: 'Ilimitado',
        },
    },

    auth: {
        signIn: {
            title: 'Entrar',
            subtitle: 'Bem-vindo de volta! Faça login na sua conta.',
            emailLabel: 'E-mail',
            emailPlaceholder: 'Digite seu e-mail',
            usernameLabel: 'Nome de usuário',
            usernamePlaceholder: 'Digite seu nome de usuário',
            passwordLabel: 'Senha',
            passwordPlaceholder: 'Digite sua senha',
            rememberMe: 'Lembrar-me',
            forgotPassword: 'Esqueceu a senha?',
            signInButton: 'Entrar',
            signInWithProvider: 'Entrar com {provider}',
            orDivider: 'ou',
            noAccount: 'Não tem uma conta?',
            createAccount: 'Criar conta',
            success: 'Login realizado com sucesso',
            welcomeBack: 'Bem-vindo de volta!',
        },

        signUp: {
            title: 'Criar Conta',
            subtitle: 'Comece criando sua conta.',
            firstNameLabel: 'Nome',
            firstNamePlaceholder: 'Digite seu nome',
            lastNameLabel: 'Sobrenome',
            lastNamePlaceholder: 'Digite seu sobrenome',
            emailLabel: 'E-mail',
            emailPlaceholder: 'Digite seu e-mail',
            usernameLabel: 'Nome de usuário',
            usernamePlaceholder: 'Escolha um nome de usuário',
            passwordLabel: 'Senha',
            passwordPlaceholder: 'Crie uma senha',
            confirmPasswordLabel: 'Confirmar Senha',
            confirmPasswordPlaceholder: 'Confirme sua senha',
            phoneLabel: 'Número de telefone',
            phonePlaceholder: 'Digite seu número de telefone',
            signUpButton: 'Criar Conta',
            signUpWithProvider: 'Registrar-se com {provider}',
            orDivider: 'ou',
            hasAccount: 'Já tem uma conta?',
            signInLink: 'Fazer login',
            termsAcceptance: 'Ao criar uma conta, você concorda com nossos',
            termsOfService: 'Termos de Serviço',
            privacyPolicy: 'Política de Privacidade',
            success: 'Conta criada com sucesso',
            welcomeMessage: 'Bem-vindo ao Frank Auth!',
        },

        passwordReset: {
            title: 'Redefinir Senha',
            subtitle: 'Digite seu e-mail para receber instruções de redefinição.',
            emailLabel: 'E-mail',
            emailPlaceholder: 'Digite seu e-mail',
            sendResetButton: 'Enviar Link',
            backToSignIn: 'Voltar ao login',
            success: 'Link de redefinição enviado',
            checkEmail: 'Verifique seu e-mail para instruções',
            resetPassword: 'Redefinir Senha',
            newPasswordLabel: 'Nova Senha',
            newPasswordPlaceholder: 'Digite nova senha',
            confirmNewPasswordLabel: 'Confirmar Nova Senha',
            confirmNewPasswordPlaceholder: 'Confirme nova senha',
            resetButton: 'Redefinir Senha',
            passwordUpdated: 'Senha atualizada com sucesso',
        },

        mfa: {
            title: 'Autenticação de Dois Fatores',
            subtitle: 'Digite o código de verificação do seu app autenticador.',
            codeLabel: 'Código de Verificação',
            codePlaceholder: 'Digite código de 6 dígitos',
            verifyButton: 'Verificar',
            resendCode: 'Reenviar código',
            useBackupCode: 'Usar código de backup',
            backupCodeLabel: 'Código de Backup',
            backupCodePlaceholder: 'Digite código de backup',
            useAuthenticator: 'Usar app autenticador',
            success: 'Verificado com sucesso',
            setup: {
                title: 'Configurar Autenticação de Dois Fatores',
                subtitle: 'Adicione uma camada extra de segurança à sua conta.',
                step1: 'Passo 1: Baixe um app autenticador',
                step2: 'Passo 2: Escaneie o código QR',
                step3: 'Passo 3: Digite o código de verificação',
                downloadApp: 'Baixe um app compatível como Google Authenticator ou Authy',
                scanQR: 'Escaneie este código QR com seu app autenticador',
                enterCode: 'Digite o código de 6 dígitos do seu app',
                manualEntry: 'Ou digite esta chave manualmente:',
                secretKey: 'Chave Secreta',
                verificationCode: 'Código de Verificação',
                enableButton: 'Ativar Autenticação de Dois Fatores',
                backupCodes: 'Códigos de Backup',
                saveBackupCodes: 'Salve estes códigos de backup em local seguro',
                backupCodesWarning: 'Estes códigos podem ser usados se você perder acesso ao seu app autenticador',
            },
        },

        passkeys: {
            title: 'Chaves de Acesso',
            subtitle: 'Use seu dispositivo para fazer login com segurança sem senhas.',
            setup: 'Configurar chave de acesso',
            use: 'Usar chave de acesso',
            notSupported: 'Chaves de acesso não são suportadas neste dispositivo',
            setupButton: 'Configurar Chave de Acesso',
            useButton: 'Usar Chave de Acesso',
            success: 'Operação de chave de acesso bem-sucedida',
            registered: 'Chave de acesso registrada com sucesso',
            manage: {
                title: 'Gerenciar Chaves de Acesso',
                noPasskeys: 'Nenhuma chave de acesso configurada',
                addPasskey: 'Adicionar Chave de Acesso',
                deviceName: 'Nome do Dispositivo',
                createdAt: 'Criado',
                lastUsed: 'Último Uso',
                remove: 'Remover',
                removeConfirm: 'Tem certeza que deseja remover esta chave de acesso?',
            },
        },

        oauth: {
            signInWith: 'Entrar com {provider}',
            signUpWith: 'Registrar-se com {provider}',
            continueWith: 'Continuar com {provider}',
            connecting: 'Conectando...',
            success: 'Conectado com sucesso',
            error: 'Falha na conexão',
            cancelled: 'Conexão cancelada',
            providers: {
                google: 'Google',
                github: 'GitHub',
                microsoft: 'Microsoft',
                facebook: 'Facebook',
                apple: 'Apple',
                twitter: 'Twitter',
                linkedin: 'LinkedIn',
                discord: 'Discord',
                slack: 'Slack',
                spotify: 'Spotify',
            },
        },

        verification: {
            email: {
                title: 'Verificar E-mail',
                subtitle: 'Verifique seu e-mail e clique no link de verificação.',
                checkEmail: 'Enviamos um link de verificação para seu e-mail',
                resendEmail: 'Reenviar e-mail',
                changeEmail: 'Alterar e-mail',
                success: 'E-mail verificado com sucesso',
                verified: 'Seu e-mail foi verificado',
            },
            phone: {
                title: 'Verificar Telefone',
                subtitle: 'Digite o código de verificação enviado para seu telefone.',
                codeLabel: 'Código de Verificação',
                codePlaceholder: 'Digite código de 6 dígitos',
                resendCode: 'Reenviar código',
                verifyButton: 'Verificar Telefone',
                success: 'Telefone verificado com sucesso',
                verified: 'Seu telefone foi verificado',
            },
        },

        magicLink: {
            title: 'Link Mágico',
            subtitle: 'Faça login com um link seguro enviado para seu e-mail.',
            emailLabel: 'E-mail',
            emailPlaceholder: 'Digite seu e-mail',
            sendLinkButton: 'Enviar Link Mágico',
            checkEmail: 'Verifique seu e-mail pelo link mágico',
            success: 'Link mágico enviado com sucesso',
            expired: 'Link mágico expirou',
            invalid: 'Link mágico inválido',
        },

        logout: {
            title: 'Sair',
            subtitle: 'Tem certeza que deseja sair?',
            button: 'Sair',
            confirm: 'Sair',
            success: 'Saiu com sucesso',
            goodbye: 'Até logo!',
        },

        session: {
            expired: 'Sua sessão expirou',
            invalid: 'Sessão inválida',
            refresh: 'Atualizar sessão',
            refreshing: 'Atualizando sessão...',
            multipleWarning: 'Você está logado em múltiplos dispositivos',
            deviceLimit: 'Limite de dispositivos atingido',
        },
    },

    user: {
        profile: {
            title: 'Perfil',
            personalInfo: 'Informações Pessoais',
            accountInfo: 'Informações da Conta',
            security: 'Segurança',
            preferences: 'Preferências',
            firstName: 'Nome',
            lastName: 'Sobrenome',
            email: 'E-mail',
            username: 'Nome de usuário',
            phone: 'Telefone',
            bio: 'Biografia',
            website: 'Site',
            location: 'Localização',
            timezone: 'Fuso horário',
            language: 'Idioma',
            avatar: 'Foto do Perfil',
            changeAvatar: 'Alterar Foto',
            removeAvatar: 'Remover Foto',
            updateProfile: 'Atualizar Perfil',
            profileUpdated: 'Perfil atualizado com sucesso',
        },

        security: {
            title: 'Segurança',
            changePassword: 'Alterar Senha',
            currentPassword: 'Senha Atual',
            newPassword: 'Nova Senha',
            confirmPassword: 'Confirmar Senha',
            passwordStrength: 'Força da Senha',
            passwordRequirements: 'Requisitos da Senha',
            twoFactor: 'Autenticação de Dois Fatores',
            enableTwoFactor: 'Ativar Autenticação de Dois Fatores',
            disableTwoFactor: 'Desativar Autenticação de Dois Fatores',
            twoFactorEnabled: 'Autenticação de dois fatores ativada',
            twoFactorDisabled: 'Autenticação de dois fatores desativada',
            backupCodes: 'Códigos de Backup',
            viewBackupCodes: 'Ver Códigos de Backup',
            regenerateBackupCodes: 'Regenerar Códigos de Backup',
            devices: 'Dispositivos',
            trustedDevices: 'Dispositivos Confiáveis',
            removeDevice: 'Remover Dispositivo',
            deviceRemoved: 'Dispositivo removido com sucesso',
            sessions: 'Sessões',
            activeSessions: 'Sessões Ativas',
            terminateSession: 'Terminar Sessão',
            terminateAllSessions: 'Terminar Todas as Sessões',
            sessionTerminated: 'Sessão terminada',
            connectedAccounts: 'Contas Conectadas',
            disconnect: 'Desconectar',
            accountDisconnected: 'Conta desconectada',
            deleteAccount: 'Excluir Conta',
            deleteAccountWarning: 'Esta ação não pode ser desfeita',
            deleteAccountConfirm: 'Excluir Minha Conta',
            accountDeleted: 'Conta excluída com sucesso',
        },

        preferences: {
            title: 'Preferências',
            theme: 'Tema',
            lightMode: 'Modo Claro',
            darkMode: 'Modo Escuro',
            systemMode: 'Padrão do Sistema',
            notifications: 'Notificações',
            emailNotifications: 'Notificações por E-mail',
            pushNotifications: 'Notificações Push',
            smsNotifications: 'Notificações SMS',
            marketingEmails: 'E-mails de Marketing',
            securityAlerts: 'Alertas de Segurança',
            accountActivity: 'Atividade da Conta',
            productUpdates: 'Atualizações do Produto',
            preferences: 'Preferências',
            preferencesUpdated: 'Preferências atualizadas com sucesso',
        },
    },

    organization: {
        general: {
            title: 'Organização',
            name: 'Nome da Organização',
            description: 'Descrição',
            website: 'Site',
            logo: 'Logo',
            settings: 'Configurações',
            members: 'Membros',
            billing: 'Faturamento',
            usage: 'Uso',
            security: 'Segurança',
            integrations: 'Integrações',
            audit: 'Log de Auditoria',
            support: 'Suporte',
        },

        profile: {
            title: 'Perfil da Organização',
            updateOrganization: 'Atualizar Organização',
            organizationUpdated: 'Organização atualizada com sucesso',
            logo: 'Logo',
            changeLogo: 'Alterar Logo',
            removeLogo: 'Remover Logo',
            brandColors: 'Cores da Marca',
            primaryColor: 'Cor Primária',
            secondaryColor: 'Cor Secundária',
            customBranding: 'Marca Personalizada',
            domain: 'Domínio',
            customDomain: 'Domínio Personalizado',
            verifyDomain: 'Verificar Domínio',
            domainVerified: 'Domínio verificado',
            domainPending: 'Verificação de domínio pendente',
            contact: 'Informações de Contato',
            contactEmail: 'E-mail de Contato',
            supportUrl: 'URL de Suporte',
            address: 'Endereço',
            country: 'País',
            timezone: 'Fuso Horário',
        },

        members: {
            title: 'Membros',
            totalMembers: 'Total de Membros',
            activeMembers: 'Membros Ativos',
            pendingInvitations: 'Convites Pendentes',
            roles: 'Funções',
            permissions: 'Permissões',
            inviteMember: 'Convidar Membro',
            inviteMembers: 'Convidar Membros',
            emailAddress: 'Endereço de E-mail',
            role: 'Função',
            customMessage: 'Mensagem Personalizada',
            sendInvitation: 'Enviar Convite',
            invitationSent: 'Convite enviado com sucesso',
            resendInvitation: 'Reenviar Convite',
            cancelInvitation: 'Cancelar Convite',
            invitationCancelled: 'Convite cancelado',
            memberName: 'Nome',
            memberEmail: 'E-mail',
            memberRole: 'Função',
            memberStatus: 'Status',
            memberJoined: 'Ingressou',
            lastActive: 'Última Atividade',
            changeRole: 'Alterar Função',
            removeMember: 'Remover Membro',
            removeMemberConfirm: 'Tem certeza que deseja remover este membro?',
            memberRemoved: 'Membro removido com sucesso',
            transferOwnership: 'Transferir Propriedade',
            transferOwnershipConfirm: 'Tem certeza que deseja transferir a propriedade?',
            ownershipTransferred: 'Propriedade transferida com sucesso',
            bulkActions: 'Ações em Lote',
            selectAll: 'Selecionar Tudo',
            selectedMembers: '{count} membros selecionados',
            bulkRemove: 'Remover Selecionados',
            bulkChangeRole: 'Alterar Função',
            export: 'Exportar',
            exportMembers: 'Exportar Membros',
        },

        roles: {
            title: 'Funções',
            createRole: 'Criar Função',
            editRole: 'Editar Função',
            deleteRole: 'Excluir Função',
            roleName: 'Nome da Função',
            roleDescription: 'Descrição',
            permissions: 'Permissões',
            systemPermissions: 'Permissões do Sistema',
            organizationPermissions: 'Permissões da Organização',
            memberPermissions: 'Permissões de Membro',
            billingPermissions: 'Permissões de Faturamento',
            defaultRole: 'Função Padrão',
            customRole: 'Função Personalizada',
            roleCreated: 'Função criada com sucesso',
            roleUpdated: 'Função atualizada com sucesso',
            roleDeleted: 'Função excluída com sucesso',
            assignRole: 'Atribuir Função',
            unassignRole: 'Remover Função',
            roleAssigned: 'Função atribuída com sucesso',
            roleUnassigned: 'Função removida com sucesso',
            owner: 'Proprietário',
            admin: 'Administrador',
            member: 'Membro',
            guest: 'Convidado',
            viewer: 'Visualizador',
            editor: 'Editor',
            manager: 'Gerente',
        },

        settings: {
            title: 'Configurações',
            general: 'Geral',
            authentication: 'Autenticação',
            security: 'Segurança',
            integrations: 'Integrações',
            advanced: 'Avançado',
            allowPublicSignup: 'Permitir Registro Público',
            requireEmailVerification: 'Exigir Verificação de E-mail',
            allowUsernameSignup: 'Permitir Registro com Nome de Usuário',
            passwordPolicy: 'Política de Senhas',
            minPasswordLength: 'Comprimento Mínimo da Senha',
            requireUppercase: 'Exigir Maiúsculas',
            requireLowercase: 'Exigir Minúsculas',
            requireNumbers: 'Exigir Números',
            requireSymbols: 'Exigir Símbolos',
            sessionDuration: 'Duração da Sessão',
            mfaRequired: 'Exigir MFA',
            allowedDomains: 'Domínios Permitidos',
            blockedDomains: 'Domínios Bloqueados',
            ipWhitelist: 'Lista Branca de IP',
            ssoEnabled: 'SSO Ativado',
            ssoProvider: 'Provedor SSO',
            auditLogRetention: 'Retenção do Log de Auditoria',
            dataExport: 'Exportação de Dados',
            deleteOrganization: 'Excluir Organização',
            deleteOrganizationWarning: 'Isso excluirá permanentemente a organização e todos os seus dados',
            deleteOrganizationConfirm: 'Excluir Organização',
            organizationDeleted: 'Organização excluída com sucesso',
            settingsUpdated: 'Configurações atualizadas com sucesso',
        },

        billing: {
            title: 'Faturamento',
            plan: 'Plano',
            currentPlan: 'Plano Atual',
            usage: 'Uso',
            billing: 'Faturamento',
            invoices: 'Faturas',
            paymentMethod: 'Método de Pagamento',
            subscription: 'Assinatura',
            seats: 'Assentos',
            usedSeats: 'Assentos Usados',
            availableSeats: 'Assentos Disponíveis',
            addSeats: 'Adicionar Assentos',
            removeSeats: 'Remover Assentos',
            monthlyBilling: 'Faturamento Mensal',
            yearlyBilling: 'Faturamento Anual',
            upgrade: 'Upgrade',
            downgrade: 'Downgrade',
            cancel: 'Cancelar',
            pauseSubscription: 'Pausar Assinatura',
            resumeSubscription: 'Retomar Assinatura',
            billingHistory: 'Histórico de Faturamento',
            downloadInvoice: 'Baixar',
            updatePaymentMethod: 'Atualizar Método de Pagamento',
            paymentMethodUpdated: 'Método de pagamento atualizado',
            subscriptionUpdated: 'Assinatura atualizada',
            subscriptionCancelled: 'Assinatura cancelada',
            subscriptionPaused: 'Assinatura pausada',
            subscriptionResumed: 'Assinatura retomada',
            trialExpired: 'Período de teste expirado',
            trialDaysLeft: '{days} dias restantes no período de teste',
            upgradeNow: 'Fazer Upgrade Agora',
        },

        invitations: {
            title: 'Convites',
            youreInvited: 'Você foi convidado!',
            invitedBy: 'Convidado por',
            invitedTo: 'Convidado para se juntar',
            roleOffered: 'Função oferecida',
            acceptInvitation: 'Aceitar Convite',
            declineInvitation: 'Recusar',
            invitationAccepted: 'Convite aceito',
            invitationDeclined: 'Convite recusado',
            invitationExpired: 'Convite expirado',
            invitationInvalid: 'Convite inválido',
            alreadyMember: 'Já é membro',
            pendingInvitations: 'Convites Pendentes',
            sentInvitations: 'Enviados',
            receivedInvitations: 'Recebidos',
            invitationDetails: 'Detalhes do Convite',
            expiresAt: 'Expira',
            customMessage: 'Mensagem',
        },
    },

    validation: {
        required: '{field} é obrigatório',
        email: 'Por favor, insira um endereço de e-mail válido',
        phone: 'Por favor, insira um número de telefone válido',
        url: 'Por favor, insira uma URL válida',
        minLength: '{field} deve ter pelo menos {min} caracteres',
        maxLength: '{field} deve ter no máximo {max} caracteres',
        min: '{field} deve ser pelo menos {min}',
        max: '{field} deve ser no máximo {max}',
        pattern: 'Formato de {field} é inválido',
        passwordMismatch: 'As senhas não coincidem',
        invalidFormat: 'Formato inválido',
        invalid: '{field} é inválido',
        tooShort: 'Muito curto',
        tooLong: 'Muito longo',
        tooSmall: 'Muito pequeno',
        tooLarge: 'Muito grande',
        notFound: 'Não encontrado',
        alreadyExists: 'Já existe',
        expired: 'Expirado',
        weak: 'Fraca',
        strong: 'Forte',
        medium: 'Média',
        passwordStrength: {
            veryWeak: 'Muito fraca',
            weak: 'Fraca',
            fair: 'Razoável',
            good: 'Boa',
            strong: 'Forte',
        },
        passwordRequirements: {
            minLength: 'Pelo menos {min} caracteres',
            uppercase: 'Pelo menos uma letra maiúscula',
            lowercase: 'Pelo menos uma letra minúscula',
            number: 'Pelo menos um número',
            symbol: 'Pelo menos um caractere especial',
        },
    },

    errors: {
        generic: {
            unknown: 'Ocorreu um erro desconhecido',
            network: 'Erro de rede ocorreu',
            timeout: 'Tempo limite da requisição esgotado',
            serverError: 'Erro do servidor ocorreu',
            notFound: 'Recurso não encontrado',
            unauthorized: 'Acesso não autorizado',
            forbidden: 'Acesso negado',
            badRequest: 'Requisição inválida',
            conflict: 'Conflito ocorreu',
            tooManyRequests: 'Muitas requisições',
            maintenance: 'Sistema em manutenção',
            offline: 'Você está offline',
        },

        auth: {
            invalidCredentials: 'E-mail ou senha inválidos',
            accountLocked: 'Conta está bloqueada',
            accountDisabled: 'Conta está desabilitada',
            accountNotVerified: 'Conta não está verificada',
            sessionExpired: 'Sessão expirou',
            invalidToken: 'Token inválido',
            mfaRequired: 'Autenticação de dois fatores necessária',
            invalidMfaCode: 'Código de verificação inválido',
            passkeyNotSupported: 'Chaves de acesso não suportadas',
            passkeyFailed: 'Autenticação por chave de acesso falhou',
            oauthFailed: 'Autenticação OAuth falhou',
            oauthCancelled: 'Autenticação OAuth cancelada',
            magicLinkExpired: 'Link mágico expirou',
            magicLinkInvalid: 'Link mágico inválido',
            passwordTooWeak: 'Senha muito fraca',
            passwordReused: 'Senha foi usada recentemente',
            emailNotVerified: 'E-mail não está verificado',
            phoneNotVerified: 'Telefone não está verificado',
            invitationExpired: 'Convite expirou',
            invitationInvalid: 'Convite inválido',
            invitationAlreadyAccepted: 'Convite já aceito',
        },

        organization: {
            notFound: 'Organização não encontrada',
            accessDenied: 'Acesso negado',
            memberLimitReached: 'Limite de membros atingido',
            ownerRequired: 'Função de proprietário necessária',
            cannotRemoveOwner: 'Não é possível remover proprietário da organização',
            cannotRemoveSelf: 'Não é possível remover a si mesmo',
            alreadyMember: 'Já é membro',
            notMember: 'Não é membro',
            invalidRole: 'Função inválida',
            roleNotFound: 'Função não encontrada',
            domainTaken: 'Domínio já está em uso',
            domainInvalid: 'Domínio inválido',
            seatLimitReached: 'Limite de assentos atingido',
            subscriptionRequired: 'Assinatura necessária',
            paymentFailed: 'Pagamento falhou',
        },

        validation: {
            invalidEmail: 'Endereço de e-mail inválido',
            invalidPhone: 'Número de telefone inválido',
            invalidUrl: 'URL inválida',
            fieldRequired: 'Este campo é obrigatório',
            fieldTooShort: 'Este campo é muito curto',
            fieldTooLong: 'Este campo é muito longo',
            fieldInvalid: 'Este campo é inválido',
            passwordsDoNotMatch: 'As senhas não coincidem',
            emailTaken: 'E-mail já está em uso',
            usernameTaken: 'Nome de usuário já está em uso',
            phoneNumberTaken: 'Número de telefone já está em uso',
            domainTaken: 'Domínio já está em uso',
        },
    },

    success: {
        generic: {
            saved: 'Salvo com sucesso',
            updated: 'Atualizado com sucesso',
            created: 'Criado com sucesso',
            deleted: 'Excluído com sucesso',
            sent: 'Enviado com sucesso',
            completed: 'Concluído com sucesso',
            copied: 'Copiado para área de transferência',
            uploaded: 'Carregado com sucesso',
            downloaded: 'Baixado com sucesso',
            imported: 'Importado com sucesso',
            exported: 'Exportado com sucesso',
        },

        auth: {
            signedIn: 'Login realizado com sucesso',
            signedUp: 'Conta criada com sucesso',
            signedOut: 'Logout realizado com sucesso',
            passwordChanged: 'Senha alterada com sucesso',
            passwordReset: 'Senha redefinida com sucesso',
            emailVerified: 'E-mail verificado com sucesso',
            phoneVerified: 'Telefone verificado com sucesso',
            mfaEnabled: 'Autenticação de dois fatores ativada',
            mfaDisabled: 'Autenticação de dois fatores desativada',
            passkeyAdded: 'Chave de acesso adicionada com sucesso',
            passkeyRemoved: 'Chave de acesso removida com sucesso',
            accountConnected: 'Conta conectada com sucesso',
            accountDisconnected: 'Conta desconectada com sucesso',
        },

        organization: {
            created: 'Organização criada com sucesso',
            updated: 'Organização atualizada com sucesso',
            deleted: 'Organização excluída com sucesso',
            memberInvited: 'Membro convidado com sucesso',
            memberRemoved: 'Membro removido com sucesso',
            roleChanged: 'Função alterada com sucesso',
            ownershipTransferred: 'Propriedade transferida com sucesso',
            settingsUpdated: 'Configurações atualizadas com sucesso',
            domainVerified: 'Domínio verificado com sucesso',
            subscriptionUpdated: 'Assinatura atualizada com sucesso',
            paymentMethodUpdated: 'Método de pagamento atualizado com sucesso',
        },
    },

    components: {
        loading: {
            generic: 'Carregando...',
            signIn: 'Entrando...',
            signUp: 'Criando conta...',
            profile: 'Carregando perfil...',
            organization: 'Carregando organização...',
            members: 'Carregando membros...',
            settings: 'Carregando configurações...',
            verification: 'Verificando...',
            mfa: 'Verificando código...',
            passkey: 'Autenticando...',
            oauth: 'Conectando...',
        },

        empty: {
            generic: 'Nenhum dado disponível',
            members: 'Nenhum membro encontrado',
            invitations: 'Nenhum convite',
            sessions: 'Nenhuma sessão ativa',
            devices: 'Nenhum dispositivo confiável',
            notifications: 'Nenhuma notificação',
            history: 'Nenhum histórico',
            logs: 'Nenhum log',
            search: 'Nenhum resultado de pesquisa',
            filter: 'Nenhum resultado corresponde ao seu filtro',
        },

        confirm: {
            delete: 'Tem certeza que deseja excluir isso?',
            remove: 'Tem certeza que deseja remover isso?',
            cancel: 'Tem certeza que deseja cancelar?',
            logout: 'Tem certeza que deseja sair?',
            transfer: 'Tem certeza que deseja transferir a propriedade?',
            disable: 'Tem certeza que deseja desabilitar isso?',
            enable: 'Tem certeza que deseja habilitar isso?',
            reset: 'Tem certeza que deseja redefinir isso?',
            clear: 'Tem certeza que deseja limpar isso?',
            proceed: 'Deseja prosseguir?',
            areYouSure: 'Tem certeza?',
            cannotUndo: 'Esta ação não pode ser desfeita.',
            permanentAction: 'Esta é uma ação permanente.',
        },

        help: {
            password: 'Escolha uma senha forte com pelo menos 8 caracteres, incluindo maiúsculas, minúsculas, números e símbolos.',
            mfa: 'A autenticação de dois fatores adiciona uma camada extra de segurança à sua conta.',
            passkey: 'Chaves de acesso usam a biometria ou PIN do seu dispositivo para fazer login com segurança sem senhas.',
            backup: 'Códigos de backup podem ser usados se você perder acesso ao seu app autenticador.',
            domain: 'Domínios personalizados permitem que seus usuários acessem seu app do seu próprio domínio.',
            webhook: 'Webhooks notificam sua aplicação quando eventos ocorrem na sua organização.',
            apiKey: 'Chaves de API permitem que suas aplicações se autentiquem com a API do Frank Auth.',
            role: 'Funções definem quais ações os membros podem executar na sua organização.',
            permission: 'Permissões concedem acesso específico a recursos e funcionalidades.',
            billing: 'Gerencie sua assinatura, método de pagamento e histórico de faturamento.',
            usage: 'Monitore o uso e limites da sua organização.',
        },
    },
};